export const isEvenNumber = (number: number): boolean => {
  try {
    return number % 2 === 0;
  } catch {
    return false;
  }
};
